export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    showDoctorConsultConfig({commit}) {
        commit('showDoctorConsultConfig');
    },
    showDoctorConsultTable({commit}) {
        commit('showDoctorConsultTable');
    },
    showDoctorConsultForm({commit}) {
        commit('showDoctorConsultForm');
    },
    showDoctorHoliday({commit}) {
        commit('showDoctorHoliday');
    },
    showDoctorHolidayTable({commit}) {
        commit('showDoctorHolidayTable');
    },
    showDoctorHolidayForm({commit}) {
        commit('showDoctorHolidayForm');
    },
    modifyCompanySiteToRoomSelect({commit}, siteId) {
        commit('modifyCompanySiteToRoomSelect', siteId);
    }
}
